export const PAGINATION_DELTA = 1
export const FIRST_PAGINATION_INDEX = 1
export const DATA_SELECTOR_ATTRIBUTE_FOR_SEO = 'pagination-last'
